import "./FoodForm.css";

import useFoodForm from "./hooks/useFoodForm";

import ImageSection from "./sections/ImageSection/ImageSection";
import BasicInfoSection from "./sections/BasicInfoSection/BasicInfoSection";
import ClassificationSection from "./sections/ClassificationSection/ClassificationSection";
import PricingSection from "./sections/PricingSection/PricingSection";
import AvailabilitySection from "./sections/AvailabilitySection/AvailabilitySection";
import ScheduleSection from "./sections/ScheduleSection/ScheduleSection";
import TagsSection from "./sections/TagsSection/TagsSection";

function FoodForm({
  initialData = {},
  onSubmit,
  loading = false,
}) {

  const {
    formData,
    updateField,
    addTag,
    removeTag,
    resetForm,
  } = useFoodForm(initialData);

  const handleSubmit = (e) => {

    e.preventDefault();

    onSubmit(formData);

  };

  return (

    <form
      className="food-form"
      onSubmit={handleSubmit}
    >

      <ImageSection
        formData={formData}
        updateField={updateField}
      />

      <BasicInfoSection
        formData={formData}
        updateField={updateField}
      />

      <ClassificationSection
        formData={formData}
        updateField={updateField}
      />

      <PricingSection
        formData={formData}
        updateField={updateField}
      />

      <AvailabilitySection
        formData={formData}
        updateField={updateField}
      />

      <ScheduleSection
        formData={formData}
        updateField={updateField}
      />

      <TagsSection
        formData={formData}
        addTag={addTag}
        removeTag={removeTag}
      />

      <div className="food-form-actions">

        <button
          type="button"
          className="secondary-btn"
          onClick={resetForm}
        >
          Reset
        </button>

        <button
          type="submit"
          className="primary-btn"
          disabled={loading}
        >
          {loading ? "Saving..." : "Save Food"}
        </button>

      </div>

    </form>

  );

}

export default FoodForm;